// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.locationMobile = this.element.getAttribute('data-location-mobile');
  }

  toggleDetails() {
    if(screen.width > 639) {
      document.querySelectorAll('.c-education-day-details').forEach((item)=> {
        item.classList.add('hidden');
      });
      document.getElementById(this.locationMobile).classList.toggle('hidden');
      document.getElementById(this.locationMobile).querySelector('.c-education-day-details__title').innerHTML = this.element.getAttribute('data-title');
      document.getElementById(this.locationMobile).querySelector('.c-education-day-details__paragraph1').innerHTML = this.element.getAttribute('data-paragraph1');
      document.getElementById(this.locationMobile).querySelector('.c-education-day-details__paragraph2').innerHTML = this.element.getAttribute('data-paragraph2');
  
      document.getElementById(this.locationMobile).querySelector('.c-education-day-details__tags').innerHTML = this.element.getAttribute('data-tags');
    }
    else {
      document.querySelectorAll('.c-education-day-details').forEach((item)=> {
        item.classList.add('hidden');
      });
      document.getElementById(this.locationMobile).classList.toggle('hidden');
      document.getElementById(this.locationMobile).querySelector('.c-education-day-details__title').innerHTML = this.element.getAttribute('data-title');
      document.getElementById(this.locationMobile).querySelector('.c-education-day-details__paragraph1').innerHTML = this.element.getAttribute('data-paragraph1');
      document.getElementById(this.locationMobile).querySelector('.c-education-day-details__paragraph2').innerHTML = this.element.getAttribute('data-paragraph2');
  
      document.getElementById(this.locationMobile).querySelector('.c-education-day-details__tags').innerHTML = this.element.getAttribute('data-tags');
  
      console.log(document.getElementById(this.locationMobile).classList);
    }



  }
  
  close() {
    document.querySelectorAll('.c-education-day-details').forEach((item)=> {
      item.classList.add('hidden');
    });
  }
}
